import { render } from "./Diy.vue?vue&type=template&id=238bb7c8&scoped=true"
import script from "./Diy.vue?vue&type=script&lang=js"
export * from "./Diy.vue?vue&type=script&lang=js"

import "./Diy.vue?vue&type=style&index=0&id=238bb7c8&scoped=true&lang=css"

import exportComponent from "/usr/home/demon/projects/driven/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-238bb7c8"]])

export default __exports__